import type { MonsterTokenStyle } from '../api';

const classicArtwork = {
  Base: '/Monsters/rework/Gug.jpg',
  Dunwich: '/Monsters/TheDunwichHorror.png',
  DarkPharaoh: '/Monsters/TheDarkPharoah.png',
  Kingsport: '/KingsportExpansion.jpg',
  KingInYellow: '/KingInYellow.jpg',
  BlackGoat: '/Monsters/rework/DarkYoung.jpg',
  Innsmouth: '/Innsmouth.jpg',
  Lurker: '/Lurker.jpg',
  Miskatonic: '/UniqueItems/rework/BookoftheDead.jpg',
  FanMade: '/Monsters/rework/Cultist.jpg',
} as const;

export type ExpansionArtworkId = keyof typeof classicArtwork;

const classicIcons: Partial<Record<ExpansionArtworkId, string>> = {
  Dunwich: 'DunwichHorrorIcon', DarkPharaoh: 'DarkPharoahIcon',
  Kingsport: 'KingsportIcon', KingInYellow: 'KingInYellowIcon',
  BlackGoat: 'BlackGoatIcon', Innsmouth: 'InnsmouthIcon', Lurker: 'LurkerIcon',
};

export function getExpansionArtwork(id: ExpansionArtworkId, style: MonsterTokenStyle) {
  return style === 'Digital'
    ? `/Expansions/Digital/small/${id}.jpg`
    : classicArtwork[id];
}

export function getExpansionIcon(id: ExpansionArtworkId, style: MonsterTokenStyle): string | undefined {
  return style === 'Digital'
    ? `/Expansions/Digital/${id}Icon.png`
    : classicIcons[id] ? `/Expansions/${classicIcons[id]}.webp` : undefined;
}
